import { z } from 'zod';

import { QueuedAuditlogEvent } from '../auditlog/AuditlogEvent';
import { PersistableUnlockedAuthenticator } from '../clientCoreParameters/authenticator/PersistableUnlockedAuthenticator';

import { PersistableAccountState } from './PersistableAccountState';
import { PersistableForeignVaultSyncPredicate } from './PersistableForeignVaultSyncPredicate';
import { PersistableProfileRepo } from './PersistableProfileRepo';
import { PersistableVaultRepo } from './PersistableVaultRepo';

interface PersistableClientCore {
  accountState: PersistableAccountState;
  profileRepo: PersistableProfileRepo;
  vaultRepo: PersistableVaultRepo;
  lastKnownSyncVersion?: number;
  superUserUnlockedAuthenticators?: { [orgId: string]: PersistableUnlockedAuthenticator };
  foreignVaultSyncPredicate?: PersistableForeignVaultSyncPredicate;
  ignoredUnlock?: Date;
  auditlogEventQueue: QueuedAuditlogEvent[];
}

const PersistableClientCore = z.object({
  accountState: PersistableAccountState,
  profileRepo: PersistableProfileRepo.prefault({ profiles: [] }),
  vaultRepo: PersistableVaultRepo,
  lastKnownSyncVersion: z.number().optional(),
  superUserUnlockedAuthenticators: z
    .record(z.string(), PersistableUnlockedAuthenticator)
    .optional(),
  foreignVaultSyncPredicate: PersistableForeignVaultSyncPredicate.optional(),
  ignoredUnlock: z.date().optional(),
  auditlogEventQueue: z.array(QueuedAuditlogEvent).default([]),
});

export { PersistableClientCore };
